<template>
    <Modal ref="modalRef">
        <template v-if="control.detailsModalLabel" #title>
            {{ control.detailsModalLabel }}
        </template>

        <p v-if="control.detailsModalSubLabel" class="-mt-6 mb-6">
            {{ control.detailsModalSubLabel }}
        </p>

        <div class="flex flex-col gap-8">
            <template v-if="control.basicDescription">
                <WysiwygContent
                    :content="control.basicDescription"
                    class="mt-4"
                />
            </template>
            <template v-else>
                <template
                    v-for="choice in choicesWithoutHiddenElements"
                    :key="choice.value"
                >
                    <div
                        v-if="choice.detailsModalLabel"
                        class="flex items-start gap-8"
                    >
                        <img
                            v-if="choice.detailsModalImageUrl"
                            class="aspect-[1/1] w-20 flex-shrink-0 object-contain object-top md:w-28"
                            :src="choice.detailsModalImageUrl"
                            :alt="choice.label"
                        />

                        <div>
                            <div
                                class="-mt-0.5 flex items-center justify-between"
                            >
                                <h4>
                                    {{ choice.detailsModalLabel }}
                                </h4>

                                <div
                                    v-if="choice.detailsModalLabelAdditional"
                                    class="text-lg font-semibold text-drip"
                                >
                                    {{ choice.detailsModalLabelAdditional }}
                                </div>
                            </div>

                            <div
                                v-if="choice.detailsModalSubLabel"
                                class="mt-0.5 text-sm text-gray-600"
                                v-html="
                                    sanitizeHtml(choice.detailsModalSubLabel)
                                "
                            ></div>

                            <WysiwygContent
                                :content="choice.detailsModalDescription"
                                class="mt-4"
                            />
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/Modal.vue';
import { QuoteConfiguratorToggleControl } from '~/types/quote';

const props = defineProps<{
    control: QuoteConfiguratorToggleControl;
}>();

const modalRef = ref<InstanceType<typeof Modal> | null>(null);

const open = () => {
    if (modalRef.value) {
        modalRef.value.open();
    }
};

const choicesWithoutHiddenElements = computed(() => {
    return props.control?.choices.filter(
        (choice) => choice?.hideFromModal !== true,
    );
});

defineExpose({ open });
</script>
